module.exports = __webpack_public_path__ + "static/media/muji outcome4.7995b4ec.png";